import { Outlet } from "react-router";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { FoodsIcon } from "@foodpilot/foods";

export const CompanySettingsLayout = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                minHeight: "100vh",
                backgroundColor: "#F6F5F3",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    backgroundColor: "white",
                    borderBottom: "1px solid #E0DEDD",
                    px: theme.spacing(6.5),
                    pt: theme.spacing(2),
                }}
            >
                {/* Title */}
                <Stack direction="row" alignItems="center" gap={theme.spacing(2)} py={theme.spacing(3)}>
                    <FoodsIcon icon="transformationSteps" size={5} />
                    <Typography variant="h1" sx={{ fontSize: "32px", fontWeight: 700 }}>
                        {t("companySettings.title", "Company Settings")}
                    </Typography>
                </Stack>
            </Box>

            {/* Content */}
            <Box sx={{ flex: 1, overflow: "auto" }}>
                <Outlet />
            </Box>
        </Box>
    );
};
